module.exports = __webpack_public_path__ + "chefy-leo.png?38190436d8237ce06bf2c53fbbd496f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-leo.png
// module id = 41
// module chunks = 0